// Meta (Facebook) Pixel helper — completamente aislado y a prueba de fallos.
// Nunca debe poder romper el renderizado de la app: todo va envuelto en try/catch
// y se ejecuta después del primer paint.

let initialized = false

/**
 * Carga el código base del Pixel de Meta e inicializa con el id dado.
 * Seguro de llamar varias veces — solo corre una vez. Cualquier error se ignora.
 */
export function initMetaPixel(pixelId: string): void {
  try {
    if (typeof window === 'undefined' || initialized) return
    initialized = true

    const w = window as any
    if (w.fbq) return

    const n: any = (w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!w._fbq) w._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    w.fbq('init', pixelId)
    w.fbq('track', 'PageView')
  } catch {
    // Silencioso: el pixel jamás debe afectar la experiencia.
  }
}

/** Dispara un evento estándar del Pixel de Meta. */
export function trackPixel(
  event: string,
  params?: Record<string, unknown>,
): void {
  try {
    const w = window as any
    if (typeof window === 'undefined' || !w.fbq) return
    w.fbq('track', event, params)
  } catch {
    // Silencioso.
  }
}
